<template>
    <footer>
        <div class="container">
            <div class="row row1">
                <!-- div class="col-md-12" -->
                    <!--<alert v-model="success" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
                        <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                        <!--<strong>Sent!</strong>-->
                        <!--<p id="footer_successmsg">{{displayMsg}}</p>-->
                    <!--</alert>-->
                    <!-- div class="margin-top-bottom" -->
                        <!-- div class="row footer-container" -->
                            <div class="col-xs-12 col-md-2 text-center" style="border-width: 2px; border-color: red">
                                <div class="input-group input-md float-right">
                                    <img src="../../assets/Footer/footer-logo.png" alt="Logo" class="logo-img">
                                </div>
                            </div>
                            <form id="footer_form" v-on:submit.prevent="onSubmitEmail" v-if="currentRoute.name !== 'SignUp' && currentRoute.name !== 'Gift' && !getSiteStatus" class="col-xs-12 col-md-5">
                                <div v-if="!user" class="col-xs-12 col-md-5 input-group input-md sendrefrel  text-center">
                                    <input v-model="subscriptionForm.email" type="email" class="form-control form-control-1" placeholder="Sign up for our newsletter" title="please enter a valid email address" required>
                                    <span class="input-group-addon cursor form-control-2"><button type="submit">Sign Up</button></span>
                                </div>
                                <div v-if="user" class="col-xs-12 col-md-5 input-group input-md sendrefrel  text-center">
                                    <input v-model="subscriptionForm.email" type="email" class=" form-control form-control-1" placeholder="Refer a friend" title="please enter a valid email address" required>
                                    <span class="input-group-addon cursor  form-control-2"><button type="submit">Send Referral</button></span>
                                </div>
                            </form>
                            <div class="col-xs-12 col-md-4 footer-links  text-center">
                                <a href="https://www.facebook.com/tonenetworks/" target="new">
                                    <i class="fa fa-facebook fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://twitter.com/ToneNetworks" target="new">
                                    <i class="fa fa-twitter fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.instagram.com/tonenetworks/" target="new">
                                    <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/25037986/" target="new">
                                    <i class="fa fa-linkedin fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos" target="new">
                                    <i class="fa fa-youtube fa-2x" aria-hidden="true"></i>
                                </a>
                            </div>
                            <div class="col-xs-12 col-md-1 text-center">
                                <div class="input-group input-md float-left">
                                    <img src="../../assets/Footer/WOSB-Logo.png" alt="Logo" class="logo-img">
                                </div>
                            </div>
                        <!-- /div --><!-- <div class="row footer-container"> -->
                    <!-- /div --><!-- <div class="margin-top-bottom"> -->
                <!-- /div --><!-- <div class="col-md-12"> -->
            </div> <!-- <div class="row"> -->
                        <!-- <div class="row">
                            <div class="col-xs-12 col-md-2">
                                <div class="input-group input-md float-right">
                                    <img src="../../assets/Footer/footer-logo.png" alt="Logo" class="logo-img">
                                </div>
                            </div>
                            <form id="footer_form" v-on:submit.prevent="onSubmitEmail" v-if="currentRoute.name !== 'SignUp' && currentRoute.name !== 'Gift' && !getSiteStatus">
                            <div class="col-xs-12 col-md-6" v-if="!user">
                                <div class="input-group input-md float-right">
                                    <input v-model="subscriptionForm.email" type="email" class="form-control" placeholder="Sign up for our newsletter"  title="please enter a valid email address"  required>
                                    <span class="input-group-addon cursor"><button type="submit">Sign Up</button></span>
                                </div>
                            </div>
                                <div class="col-xs-12 col-md-6" v-if="user">
                                    <div class="input-group input-md float-right sendrefrel">
                                        <input v-model="subscriptionForm.email" type="email" class="form-control" placeholder="Refer a friend"  title="please enter a valid email address"  required>
                                        <span class="input-group-addon cursor"><button type="submit">Send Referral</button></span>
                                    </div>
                                </div>
                            </form>
                            <div class="col-xs-12 col-md-4 float-left footer-links">
                                <a href="https://www.facebook.com/tonenetworks/" target="new">
                                    <i class="fa fa-facebook fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://twitter.com/ToneNetworks" target="new">
                                    <i class="fa fa-twitter fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.instagram.com/tonenetworks/" target="new">
                                    <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/25037986/" target="new">
                                    <i class="fa fa-linkedin fa-2x" aria-hidden="true"></i>
                                </a>
                                <a href="https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos" target="new">
                                    <i class="fa fa-youtube fa-2x" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div> -->

                <!--</div>-->
                <!--<div class="row">-->
            <div class="row row1">
                <div class="col-md-12" v-if="!getSiteStatus">
                    <navbar class="footer-nav" v-bind:style="{ backgroundColor: getCorpFooterColor}">
                        <!--<li><a v-bind:href="'#/aboutus'">About</a></li>-->
                        <!--&lt;!&ndash;<li class="scroll-up"><a v-bind:href="isUserLoggedIn ? '/#giving' : '#giving_scroll'">Clicks For Good</a></li>&ndash;&gt;-->
                        <!--<li><a v-bind:href="'#/feedback'">Feedback</a></li>-->
                        <!--<li><a v-bind:href="'#/contactus'">Contact Us</a></li>-->
                        <li><router-link  :to="{ path: '/b2b'}">
                            TONE for Businesses
                        </router-link></li>
                        <li><router-link  :to="{ path: '/resources'}">
                            In the News
                        </router-link></li>
<!--                        <li v-if="articleRoute"><router-link title="TONE Articles"  :to="`${articleRoute}`">-->
<!--                            Set the TONE-->
<!--                        </router-link></li>-->
                        <li v-if="showGiftingLinks"><router-link title="send gifts"  :to="{ path: '/gifts'}">
                            Give the Gift of Tone
                        </router-link></li>
                        <li><router-link  :to="{ path: '/become-expert'}">
                           Become an Expert
                        </router-link></li>
                        <li v-if="user"><router-link  :to="{ path: '/Giving'}">
                            Giving
                        </router-link></li>
<!--                        <li><router-link  :to="{ path: '/pressrelease'}">-->
<!--                            Press Room-->
<!--                        </router-link></li>-->
                        <li><router-link  :to="{ path: '/feedback'}">
                            Feedback
                        </router-link></li>
                        <li><router-link  :to="{ path: '/contactus'}">
                            Contact Us
                        </router-link></li>
                    </navbar>
                </div>
            </div> <!-- <div class="row"> -->
                <!--</div>-->
                <!--<div class="row">-->
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="margin-bottom-20">
                        <ul class="nav nav-pills">
                            <li class="nav nav-pills footer-compnay-name">
                                © {{bYear}} TONE Networks
                            </li>
                            <li  v-if="!getSiteStatus" role="presentation" class="active"><router-link :to="{ path: '/aboutus'}" v-bind:style="{ backgroundColor: getCorpFooterColor}">
                                About
                            </router-link></li>
                            <li v-if="!getSiteStatus" role="presentation" class="active"><router-link  :to="{ path: '/privacypolicy'}" v-bind:style="{ backgroundColor: getCorpFooterColor}">
                                Privacy Policy
                            </router-link></li>
                            <li v-if="!getSiteStatus" role="presentation" class="active"><router-link class="active" :to="{ path: '/terms'}" v-bind:style="{ backgroundColor: getCorpFooterColor}">
                                Terms
                            </router-link></li>
                            <li v-if="!getSiteStatus" role="presentation" class="active"><router-link class="active" :to="{ path: '/faq'}" v-bind:style="{ backgroundColor: getCorpFooterColor}">
                                FAQ
                            </router-link></li>
                            <!--<li role="presentation" class="active">-->
                                <!--<a v-bind:href="'#/privacypolicy'">Privacy Policy</a>-->
                            <!--</li>-->
                            <!--<li role="presentation" class="active">-->
                                <!--<a v-bind:href="'#/terms'">Terms</a>-->
                            <!--</li>-->
                        </ul>
                    </div>
                </div>
            </div> <!-- <div class="row"> -->
        </div> <!-- <div class="container"> -->
    </footer>
</template>

<script>
    import { input, spinner, alert, navbar } from 'vue-strap'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'navbar': navbar
        },
        name: 'footer',
        data: function () {
            return {
                signup: {
                    email: ''
                },
                subscriptionForm: {
                    userId: null,
                    email: '',
                    name: '',
                    comments: '',
                    rating: 0,
                    newsLetterEmail: '0',
                    promotionalEmail: '0',
                    representativeCall: '0'
                },
                success: false,
                successMsg: '',
                displayMsg: '',
                placeHolderText: '',
                buttonTitle: '',
                bYear: new Date().getFullYear(),
                articleRoute: '',
                showGiftingLinks: false
            }
        },
//        watch: {
//            'user' (to, from) {
//                if (this.user) {
//                    this.placeHolderText = 'Refer a Friend'
//                    this.buttonTitle = 'Send Referral'
//                } else {
//                    this.placeHolderText = 'Sign up for our Newsletter'
//                    this.buttonTitle = 'Sign Up'
//                }
//            }
//        },
        methods: {
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onSubmitEmail () {
                var self = this
                if (this.user && this.user !== null) {
                    this.subscriptionForm.userId = this.user.userId
                    this.subscriptionForm.comments = 'Refer a Friend'
                    this.subscriptionForm.promotionalEmail = '1'
                    this.displayMsg = 'Successfully referred to your friend'
                } else {
                    this.subscriptionForm.comments = 'Newsletter Subscription'
                    this.subscriptionForm.newsLetterEmail = '1'
                    this.displayMsg = 'Successfully subscribed to newsletter'
                }
                this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase()
                if (self.verifyEmail(this.subscriptionForm.email)) {
                    this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(() => {
                        if (this.subscriptionForm.comments === 'Refer a Friend') {
                            window.logEvents('Newsletter subscription', 'Subscribed', `Newsletter subscribed by ${this.subscriptionForm.email}`)
                        } else {
                            window.logEvents('Refer a friend', 'Referred', `Refer a friend by ${this.subscriptionForm.email}`)
                        }
                        // this.successMsg = 'Successfully Subscribed'
                        self.$swal({
                            title: this.displayMsg,
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        setTimeout(() => {
                            this.success = false
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.userId = null
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.name = ''
                            this.subscriptionForm.comments = ''
                            this.subscriptionForm.rating = 0
                            this.subscriptionForm.newsLetterEmail = '0'
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.representativeCall = '0'
                        }, 2000)
                    })
                }
            }
        },
        watch: {
            'getGiftingLinksFlag' (to, from) {
                let self = this
                if (self.getGiftingLinksFlag) {
                    self.showGiftingLinks = false
                } else {
                    self.showGiftingLinks = true
                }
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'getAllArticles', 'getSiteStatus', 'getGiftingLinksFlag', 'getCorpFooterColor'
            ]),
            currentRoute () {
                return this.$route
            },
            displayMessage () {
              //  console.log('user', this.user)
                if (this.user) {
                    if (this.user.userId > 0) {
                        return 'unauth'
                    } else {
                        return 'auth'
                    }
                } else {
                    return 'unauth'
                }
            }
        },
        mounted: function () {
            this.$store.dispatch('GETALLARTICLES').then(() => {
                if (this.getAllArticles) {
                    this.articleRoute = `/setthetone/article/${this.getAllArticles[0].toneArticleId}/${this.getAllArticles[0].articleHead.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`
                } else {
                    this.articleRoute = null
                }
            })
            if (this.getGiftingLinksFlag) {
                this.showGiftingLinks = false
            } else {
                this.showGiftingLinks = true
            }
//            if (navigator.userAgent.indexOf('gonative') > -1) {
//                let items = [
//                    {
//                        'label': 'Home',
//                        'url': 'https://www1.dev-tonenetworks.com',
//                        'icon': 'fa-home'
//                    },
//                    {
//                        'subLinks': [],
//                        'label': 'Work',
//                        'url': 'https://www1.dev-tonenetworks.com/content/work',
//                        'icon': 'fa-rocket'
//                    },
//                    {
//                        'subLinks': [],
//                        'label': 'Life',
//                        'url': 'https://www1.dev-tonenetworks.com/content/life',
//                        'icon': 'fa-bolt'
//                    },
//                    {
//                        'subLinks': [],
//                        'label': 'Events',
//                        'url': 'https://www1.dev-tonenetworks.com/newevents',
//                        'icon': 'fa-calendar'
//                    },
//                    {
//                        'subLinks': [],
//                        'label': 'Profile',
//                        'url': 'https://www1.dev-tonenetworks.com/profile',
//                        'icon': 'fa-user'
//                    }
//                ]
//                var json = JSON.stringify(items)
//                window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json)
//            }
//            this.placeHolderText = this.user ? 'Refer a Friend' : 'Sign Up For Our Newsletter'
//            this.buttonTitle = this.user ? 'Send Referral' : 'Sign Up'
            var $ = window.jQuery
            $('.footer-nav li.scroll-up a').on('click', function (e) {
                // prevent page from reloading behaviour
                e.preventDefault()

                // store hash
                var hash = this.hash

                // if entire page has required selector then animate up
                if ($(hash).length) {
                    $('body, html').animate({
                        scrollTop: $(hash).offset().top
                    }, 500, function () {
                        // some other stuff
                    })
                } else {
                    // if not logged in set url for desired page
                    window.location.hash = hash
                }
            })
        }
    }

</script>
<style scoped>
    .row1 {margin-top: 2em}
    .form-control-1 {
        min-width: 250px !important;
    }
    .form-control-2 {
        min-width: 100px !important;
    }
    .footer-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo-img {
        max-width: 100%; /* Ensure the logo doesn't exceed the container width */
        height: auto; /* Maintain the aspect ratio while resizing */
        max-height: 100px; /* Set the maximum height for the logo */
    }
    .footer-compnay-name {
        color: #fff !important;
        display: inline-block;
        padding: 0;
    }
    footer .navbar-nav li {
        float: none;
        width:auto !important;
        text-align: center;
        display: inline-block;
        padding: 0 15px;
    }


    footer .footer-links {
        margin-left:auto;
        margin-right:auto;
        float:none;
        text-align: center;
    }

    footer .footer-links a {
        margin-left:1.25em;
        margin-right:1.25em;
    }
    footer form#footer_form + .footer-links {
        margin-left: 0 ;
        margin-right: 0 ;
        float:left;
        text-align:left;
    }
    footer form#footer_form + .footer-links a {
        margin-left:2.5em;
        margin-right:0;
    }
    @media(max-width:991px){
    footer .footer-links a {
        margin: 1em !important;
        float: none;
    }
    footer .footer-links {
        text-align: center !important;
    }
    }
    footer .nav-pills li a {
        color: #fff;
    }
    </style>
<style>

    body footer span.input-group-addon.cursor > button {
        height: 56px;
        display: block;
        margin: 0;
        padding: 0;
        float: none;
        width: 100%;
    }

    body footer span.input-group-addon.cursor {
        padding: 0;
        margin: 0;
    }
    footer .input-group.input-md.float-right.sendrefrel .input-group-addon{
        width:35%
    }
</style>



// WEBPACK FOOTER //
// Footer.vue?04ec8b12